export const ISSUER_TYPE = {
    PEER_DIFF_RECONCILIATION_MONITOR: "Peer Diff Reconciliation Monitor"
} as const